import React from 'react';
import PropTypes from 'prop-types';
import { map, isEmpty } from 'lodash';

const AccountPlayerProfile = ({ accountPlayer }) => {
  const rows = map(accountPlayer.profileAnswers, a =>
    <tr key={`lp-${a.id}`}>
      <td>{a.question}</td>
      <td>{a.answer}</td>
    </tr>
  )
  return (
    <div className='o-dashboard-card__wrap'>
      <strong>Learning Profile Question</strong>
      <div className='u-margin-top--small cs-bg--light table-scroll'>
        <table className='o-table o-table--bordered'>
          <thead>
            <tr>
              <th>Question</th>
              <th>Answer</th>
            </tr>
          </thead>
          <tbody>
            { isEmpty(rows) ? <tr><td className='text-center' colSpan='2'>No Data</td></tr> : rows }
          </tbody>
        </table>
      </div>
    </div>
  );
}

AccountPlayerProfile.propTypes = {
  accountPlayer: PropTypes.object.isRequired,
}

export default AccountPlayerProfile;
